import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { contactAPI } from '../../services/api';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './Contact.css';

const Contact = () => {
    useScrollAnimation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const response = await contactAPI.submit(formData);
            
            if (response.data.success) {
                toast.success(response.data.message);
                setFormData({ name: '', email: '', subject: '', message: '' });
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error sending message');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">Get In Touch</span>
                    <h1 className="section-title">Contact Us</h1>
                    <p className="section-description">We'd love to hear from you</p>
                </div>

                <div className="contact-content">
                    <div className="contact-info">
                        <div className="contact-animation-container">
                            <img src={`${process.env.PUBLIC_URL}/images/contact-animation.gif`} alt="Contact Animation" className="contact-animation" />
                        </div>
                        <div className="contact-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <div>
                                <h4>Address</h4>
                                <p>No: 324, Paper Mills Road, Perambur, Chennai - 600011, Tamil Nadu, India</p>
                            </div>
                        </div>
                        <div className="contact-item">
                            <i className="fas fa-phone"></i>
                            <div>
                                <h4>Phone</h4>
                                <p>44 4582 5212</p>
                                <p>+91 98844 88738</p>
                            </div>
                        </div>
                        <div className="contact-item">
                            <i className="fas fa-envelope"></i>
                            <div>
                                <h4>Email</h4>
                                <p>nidharsanam2013@gmail.com</p>
                            </div>
                        </div>
                        <div className="social-links">
                            <a href="#facebook"><i className="fab fa-facebook-f"></i></a>
                            <a href="#twitter"><i className="fab fa-twitter"></i></a>
                            <a href="#instagram"><i className="fab fa-instagram"></i></a>
                            <a href="#linkedin"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Your Name *</label>
                            <input 
                                type="text" 
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label>Your Email *</label>
                            <input 
                                type="email" 
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label>Subject *</label>
                            <input 
                                type="text" 
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required 
                            />
                        </div>
                        <div className="form-group">
                            <label>Your Message *</label>
                            <textarea 
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="5" 
                                required
                            ></textarea>
                        </div>
                        <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
                            {submitting ? 'Sending...' : 'Send Message'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
